import { useEffect } from 'react';

/**
 * Fängt den Android-Zurück-Button ab, solange ein Raum oder eine lokale
 * Rollenverteilung aktiv ist.
 *
 * Ohne das würde ein versehentlicher Tap auf „Zurück" die App verlassen und
 * mitten in der Runde aus dem Raum werfen. Stattdessen wird ein History-
 * Eintrag reserviert; ein Zurück-Tap meldet sich über `onBack`, statt sofort
 * zu navigieren.
 *
 * Bewusst nur ein Callback statt einer eigenen Rückfrage: Die Entscheidung
 * fällt asynchron in einem `ConfirmSheet`, und `popstate` kann nicht warten.
 * Der Aufrufer ruft `pushBackGuard()` beim Abbrechen erneut auf, damit der
 * nächste Zurück-Tap wieder hier landet.
 */
export function useBackGuard(active: boolean, onBack: () => void): void {
  useEffect(() => {
    if (!active) return;

    pushBackGuard();

    const onPopState = () => onBack();

    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [active, onBack]);
}

/** Reserviert erneut einen History-Eintrag, nachdem der Zurück-Tap verworfen wurde. */
export function pushBackGuard(): void {
  history.pushState({ bmRoom: true }, '');
}
